import React           from 'react';
import { withRouter }  from 'react-router';
import * as Components from '../Components';
import uuidv4          from '../../utils/Uuid';

class _100 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      map: this.props.map
    };
  }

  render() {
    const listItems = this.props.map._100.map((c) => {
      const Component = Components[c];
      return <Component key={uuidv4()} />;
    });
    
    return (
      <div>
        {listItems}
      </div>
    );
  }
}

export default withRouter(_100);
